<p-treeSelect
  *ngIf="frmControl"
  class="w-full"
  containerStyleClass="w-full"
  [formControl]="frmControl"
  [options]="categories"
  placeholder="Filtra per categoria..."
  [filter]="true"
  emptyMessage="Nessuna categoria trovata"
  filterPlaceholder="Cerca..."
  [showClear]="true"
  (onNodeUnselect)="unselect()"
  (onClear)="unselect()"></p-treeSelect>
